module.exports = "https://static.energy5.com/_next/static/images/rebatesBgMob-0605d25ae376207f7677feae8dfeb892.webp";